<template>
  <div style="width: 90%;margin: 0PX AUTO;">
    <van-row v-if="datalst && datalst.length > 0">
        <van-col span="6" v-for="(item,index) in datalst" :key="index">
            <img :src="item.logo" style="width: 70%;" />
        </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'FriendLinkView',
  data(){
    return {
        datalst: []
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    async getData(){
        await this.$http({
        method: 'post',
        url: 'FriendLink'
      }).then(re => {
        this.datalst = re.data
      })
    }
  }
}
</script>

<style>

</style>
